import React from 'react';

/**
 * Resunize Logo - inline SVG for perfect rendering
 * @param {Object} props
 * @param {number} props.height - Logo height in pixels (default: 36)
 * @param {boolean} props.iconOnly - Show only the icon without text (default: false)
 * @param {string} props.className - Additional CSS classes
 */
const Logo = ({ height = 36, iconOnly = false, className = '' }) => {
  const scale = height / 110;
  const width = iconOnly ? height : 340 * scale;

  if (iconOnly) {
    // Icon-only version (just the purple box with document)
    return (
      <svg 
        width={height} 
        height={height} 
        viewBox="0 0 80 80" 
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-label="Resunize"
        style={{ direction: 'ltr' }}
      >
        <defs>
          <linearGradient id="resuGradIcon" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#7B2FF7"/>
            <stop offset="100%" stopColor="#9F44FF"/>
          </linearGradient>
        </defs>
        <rect x="0" y="0" width="80" height="80" rx="16" fill="url(#resuGradIcon)"/>
        <rect x="18" y="15" width="44" height="55" rx="4" fill="white"/>
        <rect x="18" y="15" width="44" height="12" fill="#EDE7FF"/>
        <rect x="24" y="33" width="32" height="4" rx="2" fill="#C7B6FF"/>
        <rect x="24" y="43" width="28" height="4" rx="2" fill="#C7B6FF"/>
        <rect x="24" y="53" width="20" height="4" rx="2" fill="#C7B6FF"/>
      </svg>
    );
  }

  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 340 110" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Resunize"
      style={{ direction: 'ltr' }}
    >
      <defs>
        <linearGradient id="resuGradFull" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#7B2FF7"/>
          <stop offset="100%" stopColor="#9F44FF"/>
        </linearGradient>
      </defs>
      <rect x="0" y="15" width="80" height="80" rx="16" fill="url(#resuGradFull)"/>
      <rect x="18" y="30" width="44" height="55" rx="4" fill="white"/>
      <rect x="18" y="30" width="44" height="12" fill="#EDE7FF"/>
      <rect x="24" y="48" width="32" height="4" rx="2" fill="#C7B6FF"/>
      <rect x="24" y="58" width="28" height="4" rx="2" fill="#C7B6FF"/>
      <rect x="24" y="68" width="20" height="4" rx="2" fill="#C7B6FF"/>
      <text x="100" y="70" fontFamily="Inter, Arial, sans-serif" fontSize="40" fontWeight="700">
        <tspan fill="url(#resuGradFull)">Resu</tspan>
        <tspan fill="currentColor" dx="-2">nize</tspan>
      </text>
    </svg>
  );
};

export default Logo;
